<div class="navigation-breadcrumb">
  <span class="breadcrumb-text" (click)="navigateToOpsDashboard()">
    {{ pageTitleEnum.VendorManagement }} / {{ pageTitleEnum.OnboardVendor }}
  </span>
</div>

<div class="onboard-vendor-container">
  <div class="onboard-vendor-title">{{ headerTextEnum.ADD_VENDOR }}</div>
  <form [formGroup]="onboardVendorForm">
    <div class="form-container">
      <div class="form-group">
        <div class="form-section-title">
          {{ headerTextEnum.OrganisationDetails }}
        </div>
        <div class="form-fields">
          <emerald-input
            [label]="'Name of Organisation*'"
            [outlined]="true"
            [isValid]="isFieldValid('organisationName')"
            [errorText]="getFieldError('organisationName')"
            formControlName="organisationName"
          >
          </emerald-input>
          <emerald-dropdown
            [options]="associationOptions"
            [id]="'single_select'"
            [label]="'Association with Govt*'"
            [outlined]="true"
            [isValid]="isFieldValid('associationWithGovt')"
            [errorText]="getFieldError('associationWithGovt')"
            formControlName="associationWithGovt"
          >
          </emerald-dropdown>
          <emerald-input
            [label]="'Referred by'"
            [outlined]="true"
            [isValid]="isFieldValid('referredBy')"
            [errorText]="getFieldError('referredBy')"
            formControlName="referredBy"
          >
          </emerald-input>

          <textarea
            placeholder="Full Address"
            class="textarea-input"
            aria-required="true"
            rows="3"
          ></textarea>
        </div>
      </div>

      <emerald-divider
        [vertical]="false"
        [isWhite]="false"
        [allowMargin]="true"
        [title]="'horizontal divider'"
      ></emerald-divider>

      <div class="form-group">
        <div class="form-section-title">
          {{ headerTextEnum.UploadDocuments }}
        </div>

        <div class="upload-container">
          <div class="upload-info" (click)="fileUpload.click()">
            <label class="upload-label">
              {{ fieldLabels.FileUpload }}
              <span class="valid-file-info">
                {{ fieldLabels.FileUploadHint }}
              </span>
            </label>
            <emerald-button [type]="'Light'">{{ buttonLabels.BrowseFile }}</emerald-button>
            <input
              type="file"
              id="file-upload"
              class="file-input"
              (change)="onFileSelected($event)"
              formControlName="document"
              #fileUpload
            />
          </div>
          <div
            class="field-error"
            *ngIf="
              fileError ||
              (isSubmitted && onboardVendorForm.get('document')?.invalid)
            "
          >
            <span
              class="field-error-message"
              *ngIf="onboardVendorForm.get('document')?.errors?.['required']"
              >{{ errorMessages.FieldCannotBeBlank }}</span
            >
            <span class="field-error-message" *ngIf="fileError">{{
              fileError
            }}</span>
          </div>
        </div>
        <div *ngIf="selectedFile" class="selected-file">
          <emerald-icon [icon]="'insert_drive_file'"></emerald-icon>
          <div class="file-info">
            <span class="file-name">{{ selectedFile }}</span>
            <emerald-icon [icon]="'check_circle'"></emerald-icon>
            <span class="file-size">{{ fileSize }}</span>
          </div>
          <emerald-icon
            [icon]="'delete'"
            (click)="onDeleteFile()"
          ></emerald-icon>
        </div>
      </div>

      <emerald-divider
        [vertical]="false"
        [isWhite]="false"
        [allowMargin]="true"
        [title]="'horizontal divider'"
      ></emerald-divider>

      <div class="form-group">
        <div class="form-section-title">
          {{ headerTextEnum.BusinessAndBankDetails }}
        </div>
        <div class="form-fields">
          <emerald-input
            [label]="'GST Number*'"
            [outlined]="true"
            [isValid]="isFieldValid('gstNumber')"
            [errorText]="getFieldError('gstNumber')"
            formControlName="gstNumber"
          >
          </emerald-input>
          <emerald-input
            [label]="'PAN Number*'"
            [outlined]="true"
            [isValid]="isFieldValid('panNumber')"
            [errorText]="getFieldError('panNumber')"
            formControlName="panNumber"
          >
          </emerald-input>
          <emerald-input
            [label]="'Name of the Bank*'"
            [outlined]="true"
            [isValid]="isFieldValid('bankName')"
            [errorText]="getFieldError('bankName')"
            formControlName="bankName"
          >
          </emerald-input>
          <emerald-input
            [label]="'Account Number*'"
            [outlined]="true"
            [isValid]="isFieldValid('accountNumber')"
            [errorText]="getFieldError('accountNumber')"
            formControlName="accountNumber"
          >
          </emerald-input>
          <emerald-input
            [label]="'IFSC*'"
            [outlined]="true"
            [isValid]="isFieldValid('ifsc')"
            [errorText]="getFieldError('ifsc')"
            formControlName="ifsc"
          >
          </emerald-input>
        </div>
      </div>

      <emerald-divider
        [vertical]="false"
        [isWhite]="false"
        [allowMargin]="true"
        [title]="'horizontal divider'"
      ></emerald-divider>

      <div class="form-group">
        <div class="form-section-title">
          {{ headerTextEnum.AuthorisedSignatoryInformation }}
        </div>
        <div class="form-fields">
          <emerald-input
            [label]="'Name of the contact*'"
            [outlined]="true"
            [isValid]="isFieldValid('ASI_nameOfContact')"
            [errorText]="getFieldError('ASI_nameOfContact')"
            formControlName="ASI_nameOfContact"
          >
          </emerald-input>
          <emerald-input
            [label]="'Designation*'"
            [outlined]="true"
            [isValid]="isFieldValid('ASI_designation')"
            [errorText]="getFieldError('ASI_designation')"
            formControlName="ASI_designation"
          >
          </emerald-input>
          <emerald-input
            [label]="'Office Phone*'"
            [outlined]="true"
            [isValid]="isFieldValid('ASI_officePhone')"
            [errorText]="getFieldError('ASI_officePhone')"
            formControlName="ASI_officePhone"
          >
          </emerald-input>
          <emerald-input
            [label]="'Mobile*'"
            [outlined]="true"
            [isValid]="isFieldValid('ASI_mobile')"
            [errorText]="getFieldError('ASI_mobile')"
            formControlName="ASI_mobile"
          >
          </emerald-input>
          <emerald-input
            [label]="'Email ID*'"
            [outlined]="true"
            [isValid]="isFieldValid('ASI_email')"
            [errorText]="getFieldError('ASI_email')"
            formControlName="ASI_email"
          >
          </emerald-input>
          <emerald-input
            [label]="'Location*'"
            [outlined]="true"
            [isValid]="isFieldValid('ASI_location')"
            [errorText]="getFieldError('ASI_location')"
            formControlName="ASI_location"
          >
          </emerald-input>
        </div>
      </div>

      <emerald-divider
        [vertical]="false"
        [isWhite]="false"
        [allowMargin]="true"
        [title]="'horizontal divider'"
      ></emerald-divider>

      <div class="form-group">
        <div class="form-section-title">
          {{ headerTextEnum.ContactInformation }}
        </div>
        <div formArrayName="contacts" class="contact-fields">
          <div
            class="form-fields"
            *ngFor="let contact of contacts.controls; let i = index"
            [formGroupName]="i"
          >
            <emerald-input
              [label]="'Name of the contact*'"
              [outlined]="true"
              [isValid]="!isFieldInvalidArray(contacts, i, 'CI_name')"
              [errorText]="getFieldErrorTextArray(contacts, i, 'CI_name')"
              formControlName="CI_name"
            ></emerald-input>
            <emerald-input
              [label]="'Designation*'"
              [outlined]="true"
              [isValid]="!isFieldInvalidArray(contacts, i, 'CI_designation')"
              [errorText]="
                getFieldErrorTextArray(contacts, i, 'CI_designation')
              "
              formControlName="CI_designation"
            ></emerald-input>
            <emerald-input
              [label]="'Office Phone*'"
              [outlined]="true"
              [isValid]="!isFieldInvalidArray(contacts, i, 'CI_officePhone')"
              [errorText]="
                getFieldErrorTextArray(contacts, i, 'CI_officePhone')
              "
              formControlName="CI_officePhone"
            ></emerald-input>
            <emerald-input
              [label]="'Mobile*'"
              [outlined]="true"
              [isValid]="!isFieldInvalidArray(contacts, i, 'CI_mobile')"
              [errorText]="getFieldErrorTextArray(contacts, i, 'CI_mobile')"
              formControlName="CI_mobile"
            ></emerald-input>
            <emerald-input
              [label]="'Email ID*'"
              [outlined]="true"
              [isValid]="!isFieldInvalidArray(contacts, i, 'CI_email')"
              [errorText]="getFieldErrorTextArray(contacts, i, 'CI_email')"
              formControlName="CI_email"
            ></emerald-input>
            <emerald-input
              [label]="'Location*'"
              [outlined]="true"
              [isValid]="!isFieldInvalidArray(contacts, i, 'CI_location')"
              [errorText]="getFieldErrorTextArray(contacts, i, 'CI_location')"
              formControlName="CI_location"
            ></emerald-input>
            <emerald-icon
              *ngIf="contacts.length > 1"
              [icon]="'delete'"
              class="remove-contact-icon"
              (click)="removeContact(i)"
            ></emerald-icon>
          </div>
        </div>
        <emerald-button
          [label]="'Add another contact'"
          [type]="'Light'"
          (onClick)="onAddContact($event)"
        ></emerald-button>
      </div>

      <div class="button-container">
        <emerald-button [type]="'Secondary'" (onClick)="onCancel()">{{
          buttonLabels.Cancel
        }}</emerald-button>

        <emerald-button [type]="'Primary'" (onClick)="onSubmit()">
          {{ buttonLabels.Submit }}</emerald-button
        >
      </div>
    </div>
  </form>
</div>
